import config from 'config'
import React from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import { isUserAuthorized } from 'srcReact/helpers/userHelper'

const PriceCard = ({ plan, isMonthly, t, isNonProfit }) => {
  const isFreePlan = plan.contactus === t('billing.pricing.free')

  const redirectContactUs = () => {
    if (isFreePlan) return
    window.location.href = isUserAuthorized() ? `${config.webUrl}/0/support` : `${config.webUrl}/contact-us`
  }

  return (
    <div className='pricing-card--wrapper'>
      {plan.specialMessage && ((plan.specialMsgYearly && !isMonthly) || !plan.specialMsgYearly) ? (
        <span className='card-message'>{plan.specialMessage}</span>
      ) : null}
      <div className={`pricing-card is-${plan.color}`}>
        <div className='pricing-card--header'>
          <h3>{plan.title}</h3>
        </div>
        <div className='pricing-card--content'>
          <ul className='list-behaviors'>
            {plan.behaviors
              .filter((e) => (isMonthly ? !e.yearlyOnly : true))
              .map((item) => (
                <li
                  key={`${plan.id}-behavior-${item.id}`}
                  className='list-behaviors--item'
                  dangerouslySetInnerHTML={{ __html: item.textValue }}></li>
              ))}
          </ul>
        </div>
        <div className={`pricing-card--footer ${isNonProfit && 'price-changed'}`}>
          {isNonProfit ? (
            <span className={`price ${!isFreePlan && 'price-contactus'}`} role='button' onClick={redirectContactUs}>
              {plan.contactus}
              {/* {plan.hasPrice
                ? t('billing.pricing.perUser', { amount: isMonthly ? plan.priceMonthly : plan.priceYearly })
                : isMonthly
                ? plan.priceMonthly
                : plan.priceYearly} */}
            </span>
          ) : (
            <span className={`price ${!isFreePlan && 'price-contactus'}`} role='button' onClick={redirectContactUs}>
              {plan.contactus}
              {/* {plan.hasPrice
                ? t('billing.pricing.perUser', { amount: isMonthly ? plan.priceMonthly : plan.priceYearly })
                : isMonthly
                ? plan.priceMonthly
                : plan.priceYearly} */}
            </span>
          )}
          {/* {plan.withLabel &&
            (isMonthly ? (
              <p className='price-type'>{t('billing.pricing.perMonthlyBilling')}</p>
            ) : (
              <p className='price-type'>{t('billing.pricing.perYearlyBilling')}</p>
            ))} */}
        </div>
      </div>
    </div>
  )
}

PriceCard.propTypes = {
  plan: PropTypes.oneOfType([PropTypes.object]).isRequired,
  isMonthly: PropTypes.bool,
  isNonProfit: PropTypes.bool
}

PriceCard.defaultProps = {
  isMonthly: false,
  isNonProfit: false
}

export default withTranslation('common')(PriceCard)
